
import Hero from "../components/hero/Hero";
import DashboardList from "../components/dashboard-list/DashboardList";
import RythuBazarInfo from "../components/RythuBazarInfo/RythuBazarInfo";

const Home = () => {
  return (
    <>
      <Hero />
      <DashboardList />
      <RythuBazarInfo />
    </>
  );
};

export default Home;
